import { Controller } from "@hotwired/stimulus"
import { throttle, debounce } from "throttle-debounce"

export default class extends Controller {
  static targets = ["searchIcon", "loadIcon", "resetFiltersLink"]

  initialize() {
    this._search = debounce(300, this.submitForm.bind(this))
    this._loading = throttle(150, this.displayLoading.bind(this), {
      noLeading: true
    })
    if (this.hasResetFiltersLinkTarget) {
      this.resetFiltersLinkTarget.classList.toggle("hidden", !window.location.search.includes("search"))
    }
  }

  connect() {
    this.element.addEventListener(
      "turbo:submit-end",
      this.hideLoading.bind(this)
    )
  }

  disconnect() {
    this.element.removeEventListener(
      "turbo:submit-end",
      this.hideLoading.bind(this)
    )
  }

  search() {
    this._search()
    this.resetFiltersLinkTarget?.classList.remove("hidden")
  }

  submitForm() {
    this.element.requestSubmit()
    this._loading()
  }

  displayLoading() {
    if (this.hasSearchIconTarget) {
      this.searchIconTarget.classList.add("hidden")
      this.loadIconTarget.classList.remove("hidden")
    }
  }

  hideLoading() {
    if (this.hasSearchIconTarget) {
      this.searchIconTarget.classList.remove("hidden")
      this.loadIconTarget.classList.add("hidden")
    }
    this._loading.cancel({ upcomingOnly: true })
  }
}
